import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppDownloadLinks } from '../common/AppDownloadLinks';
import './CallToAction.css';

export const CallToAction: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="cta-section" id="download">
      <div className="cta-container">
        <h2 className="cta-title">{t('cta.title')}</h2>
        <p className="cta-subtitle">{t('cta.subtitle')}</p>
        <div className="cta-buttons">
          <AppDownloadLinks tone="onBrand" />
        </div>
      </div>
    </section>
  );
};
